import { render, staticRenderFns } from "./RegisterPassword.vue?vue&type=template&id=b5c03816&scoped=true"
import script from "./RegisterPassword.vue?vue&type=script&lang=js"
export * from "./RegisterPassword.vue?vue&type=script&lang=js"
import style0 from "./RegisterPassword.vue?vue&type=style&index=0&id=b5c03816&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c03816",
  null
  
)

export default component.exports